import React, { useEffect, useRef, useState } from 'react'
import { FaEyeSlash } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { useFormik } from 'formik';
import validate from '../../assests/js/validate';
import { useDispatch, useSelector } from 'react-redux';
import { setIsWidth } from '../../store/slice/currentStageSlice';
import { currentStageData } from '../../store/slice/currentStageSlice';
import GisApiServices from '../../services/GisApiServices';
import { ToastContainer, toast } from 'react-toastify';
import Select from "react-select";
import DataTable from 'react-data-table-component';
import { useNavigate } from "react-router-dom";
import * as Yup from 'yup';
export default function Security() {
    const dispatch = useDispatch()
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [distCode, setDistCode] = useState(null);
    const [ulbs, setUlbs] = useState([]);
    const [selectedUlb, setSelectedUlb] = useState(null);
    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState(null);
    const [isDistrictLoading, setIsDistrictLoading] = useState(false);
    const [isUlbLoading, setIsUlbLoading] = useState(false);
    const [isWardLoading, setIsWardLoading] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [designations, setDesignations] = useState([]);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [tab, setTab] = useState("access")
    const [manageRoles, setManageRoles] = useState("manage-users")
    const [security, setSecurity] = useState("authentication")
    const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 });
    const [showFormPass, setFormPass] = useState(false)
    const [CurrentPass, setCurentPass] = useState(true)
    const [activeTab, setActiveTab] = useState("tab1");
    const [newPass, setNewPass] = useState(true)
    const [theme, setTheme] = React.useState({ dark: false, light: false })
    const { isTheme } = useSelector((state) => state.currentStage)
    const switchDivRef = useRef(null);
    const navigate = useNavigate();
    const authData = useSelector(state => state.authToken.authData);
    const [isGetPermission, setIsGetPermission] = useState([]);

    console.log("ulbsulbs", ulbs[0]?.value)
    const onChangeTheme = (e) => {
        const { name } = e.target
        if (name === 'light') {
            setTheme({ dark: false, light: true })
        }
        if (name === 'dark') {
            setTheme({ dark: true, light: false })
        }
    }
    const handleTab = (data) => {
        setTab(data)
        setFormPass(false)
    }

    const handleManage = (data) => {
        setManageRoles(data)
    }

    const handleSecurity = (data) => {
        setSecurity(data)
    }

    const showForm = () => {
        setFormPass(true)
    }
    const handlePassword = (data) => {
        if (data === "new") {
            setNewPass(!newPass)
        } else if (data === 'current') {
            setCurentPass(!CurrentPass)
        }

    }



    const fetchUserPermission = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                role_Id: authData?.RoleID
            }
            const response = await GisApiServices.userPermissions(value);
            const getPermission = response.data?.data || [];
            console.log("data12141", getPermission?.permissions)
            setIsGetPermission(getPermission?.permissions)
        } catch (error) {
            console.error("Error fetching user roles", error);
        } finally {
        }
    };

    useEffect(() => {
        fetchUserPermission()
    }, [])



    const fetchUserRoles = async () => {
        try {
            setIsLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 3 }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setRoles(formatted);
        } catch (error) {
            console.error("Error fetching user roles", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchDepartments = async () => {
        try {
            setIsLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 1 }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setDepartments(formatted);
        } catch (error) {
            console.error("Error fetching departments", error);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchDesignations = async () => {
        try {
            setIsLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 2 }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setDesignations(formatted);
        } catch (error) {
            console.error("Error fetching designations", error);
        } finally {
            setIsLoading(false);
        }
    };




    const fetchDistricts = async () => {
        try {
            setIsDistrictLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }

            const value = {
                distCode: "0",
                ublCode: "0",
                fectchtype: "1",
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.district_Code,
                label: item.name,
            }));
            setDistricts(formatted);
        } catch (error) {
            console.error("Error fetching districts", error);
        } finally {
            setIsDistrictLoading(false);
        }
    };

    // Fetch ULBs based on selected district
    const fetchUlbs = async (districtCode) => {
        try {
            setIsUlbLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                distCode: districtCode,
                ublCode: "0",
                fectchtype: "2",
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.ulb_Code,
                label: item.name,
            }));
            setUlbs(formatted);
        } catch (error) {
            console.error("Error fetching ULBs", error);
        } finally {
            setIsUlbLoading(false);
        }
    };

    // Fetch Wards based on selected district and ULB
    const fetchWards = async (districtCode, ulbCode) => {
        try {
            setIsWardLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                distCode: districtCode,
                ublCode: ulbCode,
                fectchtype: "3",
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.ward_ID,
                label: `${item.wardNo} - ${item.name}`,
            }));
            setWards(formatted);
        } catch (error) {
            console.error("Error fetching Wards", error);
        } finally {
            setIsWardLoading(false);
        }
    };

    // Handle district selection
    const handleDistrictChange = (selectedOption) => {
        setSelectedDistrict(selectedOption);
        setSelectedUlb(null);
        setSelectedWard(null);
        setUlbs([]);
        setWards([]);
        if (selectedOption) {
            fetchUlbs(selectedOption.value);
            formik.setFieldValue("distCode", selectedOption ? selectedOption.value : "");
        }
    };

    // Handle ULB selection
    const handleUlbChange = (selectedOption) => {
        setSelectedUlb(selectedOption);
        setSelectedWard(null);
        setWards([]);
        if (selectedOption && selectedDistrict) {
            fetchWards(selectedDistrict.value, selectedOption.value);
            formik.setFieldValue("ulbCode", selectedOption ? selectedOption.value : "")
        }
    };

    const handleDerpartment = (selectedOption) => {
        setSelectedDepartment(selectedOption)
        formik.setFieldValue("departmentId", selectedOption ? selectedOption.value : "")
    }

    const handleDesignations = (selectedOption) => {
        setSelectedDesignation(selectedOption)
        formik.setFieldValue("designationId", selectedOption ? selectedOption.value : "")
    }

    const handleWard = (selectedOption) => {
        setSelectedWard(selectedOption)
        formik.setFieldValue("wardNo", selectedOption ? selectedOption.value : "")
    }

    const handleRole = (selectedOption) => {
        setSelectedRole(selectedOption)
        formik.setFieldValue("userRoleId", selectedOption ? selectedOption.value : "")
    }


    // Define the validation schema using Yup
    const validationSchema = Yup.object({
        // Personal Details
        userId: Yup.string()
            .required('User ID is required')
            .matches(/^\S*$/, 'User ID cannot contain spaces'),

        firstName: Yup.string().required('First name is required'),
        lastName: Yup.string().required('Last name is required'),
        email: Yup.string().email('Invalid email address').required('Email is required'),
        mobileNumber: Yup.string()
            .matches(/^[6-9]\d{9}$/, 'Please enter a valid 10-digit mobile number')
            .required('Mobile number is required'),
        userPassword: Yup.string().min(8, 'Password must be at least 8 characters').required('Password is required'),

        // Address Details
        address: Yup.string().required('Address is required'),
        city: Yup.string().required('City is required'),

        // These are now always required (no condition)
        pincode: Yup.string()
            .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits')
            .required('Pincode is required'),

        distCode: Yup.string().required('District is required'),

        // Conditionally Required
        ulbCode: Yup.string()
            .when('userType', {
                is: (val) => val !== 'districtuser',
                then: (schema) => schema.required('ULB is required'),
                otherwise: (schema) => schema.nullable(),
            }),

        zoneNo: Yup.string()
            .when('userType', {
                is: (val) => val !== 'districtuser',
                then: (schema) => schema.required('Zone number is required'),
                otherwise: (schema) => schema.nullable(),
            }),

        wardNo: Yup.string()
            .when('userType', {
                is: (val) => val !== 'districtuser',
                then: (schema) => schema.required('Ward is required'),
                otherwise: (schema) => schema.nullable(),
            }),

        // Profile Details
        departmentId: Yup.string().required('Department is required'),
        designationId: Yup.string().required('Designation is required'),
        userType: Yup.string().required('User type is required'),
        userRoleId: Yup.string().required('Role is required'),
    });



    const formik = useFormik({
        initialValues: {
            userId: '',
            userPassword: '',
            email: '',
            firstName: '',
            lastName: '',
            userFullName: '',
            designationId: '',
            departmentId: '',
            panNumber: 'GIUWJ8385U',
            address: '',
            city: '',
            distCode: '', // Initialize as empty
            stateCode: '23',
            countryCode: '91',
            pincode: '',
            mobileNumber: '',
            userType: '',
            ulbCode: '',
            zoneNo: '',
            wardNo: '',
            userRoleId: '',
            createdby: authData?.UserID
        },
        validationSchema,
        onSubmit: async (values, { resetForm }) => {
            const isDistrictUser = values.userType?.toLowerCase() === 'districtuser';
            const updatedValues = {
                ...values,
                userFullName: `${values.firstName} ${values.lastName}`.trim(),
                ...(isDistrictUser && {
                    ulbCode: ulbs[0]?.value,
                    zoneNo: "00",
                    wardNo: "00",
                }),
            };
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const result = await GisApiServices.newUserCreate(updatedValues, config);
            if (result.data.message === "Success") {
                toast.success(result.data.message)
                resetForm();
                // Also reset the state for Select components for a full reset
                setSelectedDistrict(null);
                setSelectedUlb(null);
                setUlbs([]);
                setSelectedWard(null);
                setWards([]);
                setSelectedDepartment(null);
                setSelectedDesignation(null);
                setSelectedRole(null);
            } else {
                toast.error(result.data.message);
            }
        }
    });

    const userRoleCreateFormik = useFormik({
        initialValues: {
            userRoleName: ''
        },
        // validate: (values) => {
        //   const errors = {};
        //   if (!values.firstname) errors.firstname = 'Required';
        //   if (!values.lastname) errors.lastname = 'Required';
        //   if (!values.email) errors.email = 'Required';
        //   if (!values.mobilenumber) errors.mobilenumber = 'Required';
        //   if (!values.pannumber) errors.pannumber = 'Required';
        //   if (!values.role) errors.role = 'Select a role';
        //   return errors;
        // },
        onSubmit: async (values, { resetForm }) => {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const result = await GisApiServices.userRoleCreate(values, config);

            if (result.data.message === "Success") {
                toast.success(result.data.message)
                resetForm();
            } else {
                toast.error(result.data.message);
            }
        }
    });

    useEffect(() => {
        dispatch(setIsWidth(false))
        dispatch(currentStageData(''))
    }, [])

    const tabs = [
        {
            id: "tab1",
            label: "Data Import",
            content: <DataImport />,
            activeImage: isTheme === 'light' ? "img/dataimport-light.svg" : "img/accessicon.png",
            inactiveImage: isTheme === 'light' ? "img/dataimport-de-light.svg" : "img/deactiveaccess.png",
            activityId: 'AS1'
        },
        {
            id: "tab2",
            label: "Data Catalog",
            content: <DataCataLog />,
            activeImage: isTheme === 'light' ? "img/datacatalog-light.svg" : "img/activesecurity.png",
            inactiveImage: isTheme === 'light' ? "img/datacatalog-de-lihgt.svg" : "img/securityicon.png",
            activityId: 'AS2'
        },
    ];

    useEffect(() => {
        dispatch(setIsWidth(false))
        dispatch(currentStageData(''))
        const updateSlider = () => {
            const activeElement = switchDivRef.current.querySelector(".active-tab-act");
            if (activeElement) {
                const { offsetLeft: left, offsetWidth: width } = activeElement;
                setSliderStyle({ left, width });
            }
        };

        updateSlider();
        window.addEventListener("resize", updateSlider);

        return () => {
            window.removeEventListener("resize", updateSlider);
        };
    }, [activeTab]);

    const handleReset = () => {
        formik.resetForm()
    }

    const customStyles = {
        control: (base, state) => ({
            ...base,
            backgroundColor: isTheme === "light" ? "rgb(245, 245, 245)" : "#002864",
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "14px",
            border: isTheme === "light" ? "#000" : "none",
            boxShadow: "none",
            outline: "none",
            opacity: state.isDisabled ? 0.6 : 1,
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
            maxHeight: "300px",
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": { display: "none" }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#16386C"
                : state.isFocused
                    ? isTheme === "light" ? "#1F509A" : "#16386C"
                    : isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
            color: state.isSelected || state.isFocused ? "#FFFFFF" : "#000", // Ensure text is white when selected or hovered
            fontSize: "14px",
            padding: "10px",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: isTheme === "light" ? "#1F509A" : "#16386C",
                color: "#FFFFFF", // Force white text on hover
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "14px"
        }),
        placeholder: (base, state) => ({
            ...base,
            color: state.isDisabled ? isTheme === "light" ? "#000" : "rgba(255, 255, 255, 0.75)" : isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "14px"
        }),
        input: (provided) => ({
            ...provided,
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "14px"
        })
    };
    const filteredTabs = tabs.filter(tab =>
        isGetPermission.some(permission => permission.activityId === tab.activityId)
    );

    useEffect(() => {
        if (filteredTabs.length > 0 && !filteredTabs.some(tab => tab.id === activeTab)) {
            setActiveTab(filteredTabs[0].id);
        }
    }, [filteredTabs]);

    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick={false}
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />

            <div >

                <div className="switch-tabs">
                    {/* Tab Buttons */}
                    <div className="switchdivact d-none" ref={switchDivRef}>
                        {filteredTabs.map((tab) => (
                            <div
                                type="button"
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`btn-access-switch ${activeTab === tab.id ? "active-tab-act" : ""}`}
                            >
                                <img
                                    src={activeTab === tab.id ? tab.activeImage : tab.inactiveImage}
                                    alt={tab.label}
                                    className="tab-icon"
                                />
                                <span>{tab.label}</span>
                            </div>
                        ))}
                        <div
                            className="acitveslider"
                            style={{ ...sliderStyle, transition: "all 0.3s ease" }}
                        ></div>
                    </div>

                    <div className="tab-content">
                        <DataImport />,
                    </div>
                </div>


                <div className="modal fade" id="addUserModal" tabIndex="-1" aria-labelledby="addUserModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl modal-dialog-centered addusermodal">
                        <div className="modal-content">
                            <div className="modal-header newuseradd">
                                <h5 className="modal-title" id="addUserModalLabel">Add New User</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    <img src="img/closebtn.svg" alt='close' width="20px" height="20px" />
                                </button>
                            </div>
                            <div className="modal-body p-0">
                                <form onSubmit={formik.handleSubmit}>
                                    <h5 className='modal-headings'>Personal Details</h5>
                                    <div className='row' style={{ rowGap: "15px" }}>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>User Id</p>
                                            <input name="userId" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.userId} placeholder='User ID*' />
                                            {formik.touched.userId && formik.errors.userId ? <div className='error-message'>{formik.errors.userId}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>First Name</p>
                                            <input name="firstName" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.firstName} placeholder='First Name*' />
                                            {formik.touched.firstName && formik.errors.firstName ? <div className='error-message'>{formik.errors.firstName}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Last Name</p>
                                            <input name="lastName" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.lastName} placeholder='Last Name*' />
                                            {formik.touched.lastName && formik.errors.lastName ? <div className='error-message'>{formik.errors.lastName}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Email</p>
                                            <input name="email" type="email" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.email} placeholder='Email Address*' />
                                            {formik.touched.email && formik.errors.email ? <div className='error-message'>{formik.errors.email}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Mobile Number</p>
                                            <input name="mobileNumber" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.mobileNumber} placeholder='Phone Number*' maxLength="10" />
                                            {formik.touched.mobileNumber && formik.errors.mobileNumber ? <div className='error-message'>{formik.errors.mobileNumber}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Passward</p>
                                            <input name="userPassword" type="password" maxLength="10" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.userPassword} placeholder='Password*' />
                                            {formik.touched.userPassword && formik.errors.userPassword ? <div className='error-message'>{formik.errors.userPassword}</div> : null}
                                        </div>
                                    </div>

                                    <h5 className='modal-headings'>User Profile Details</h5>
                                    <div className='row' style={{ rowGap: "15px" }}>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Select Role</p>
                                            <Select options={roles} value={selectedRole} onMenuOpen={fetchUserRoles} onChange={handleRole} placeholder="Select Role*" isClearable isLoading={isLoading} onBlur={() => formik.setFieldTouched('userRoleId', true)} />
                                            {formik.touched.userRoleId && formik.errors.userRoleId ? <div className='error-message'>{formik.errors.userRoleId}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Select User Type</p>
                                            <select name="userType" className="form-select" onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.userType}>
                                                <option value="" disabled>Select User Type*</option>
                                                <option value="Admin">Admin</option>
                                                <option value="User">User</option>
                                                <option value="districtuser">District User</option>
                                            </select>
                                            {formik.touched.userType && formik.errors.userType ? <div className="error-message">{formik.errors.userType}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Select Department</p>
                                            <Select options={departments} value={selectedDepartment} onMenuOpen={fetchDepartments} onChange={handleDerpartment} placeholder="Select Department*" isClearable isLoading={isLoading} onBlur={() => formik.setFieldTouched('departmentId', true)} />
                                            {formik.touched.departmentId && formik.errors.departmentId ? <div className='error-message'>{formik.errors.departmentId}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Select Designations</p>
                                            <Select options={designations} value={selectedDesignation} onMenuOpen={fetchDesignations} onChange={handleDesignations} placeholder="Select Designation*" isClearable isLoading={isLoading} onBlur={() => formik.setFieldTouched('designationId', true)} />
                                            {formik.touched.designationId && formik.errors.designationId ? <div className='error-message'>{formik.errors.designationId}</div> : null}
                                        </div>
                                    </div>

                                    <h5 className='modal-headings'>User Address Details</h5>
                                    <div className='row' style={{ rowGap: "15px" }}>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Address</p>
                                            <input name="address" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.address} placeholder='Address*' />
                                            {formik.touched.address && formik.errors.address ? <div className='error-message'>{formik.errors.address}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>City</p>
                                            <input name="city" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.city} placeholder='City*' />
                                            {formik.touched.city && formik.errors.city ? <div className='error-message'>{formik.errors.city}</div> : null}
                                        </div>
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>District</p>
                                            <Select options={districts} value={selectedDistrict} onMenuOpen={fetchDistricts} onChange={handleDistrictChange} placeholder="Select District*" isClearable isLoading={isDistrictLoading} onBlur={() => formik.setFieldTouched('distCode', true)} />
                                            {formik.touched.distCode && formik.errors.distCode ? <div className='error-message'>{formik.errors.distCode}</div> : null}
                                        </div>

                                        {formik.values.userType === "districtuser" ? null :
                                            <>
                                                <div className='col-lg-3 col-md-6'>
                                                    <p className='lebel-card-text m-0'>ULB</p>
                                                    <Select options={ulbs} value={selectedUlb} onChange={handleUlbChange} placeholder="Select ULB*" isClearable isDisabled={!selectedDistrict} isLoading={isUlbLoading} onBlur={() => formik.setFieldTouched('ulbCode', true)} />
                                                    {formik.touched.ulbCode && formik.errors.ulbCode ? <div className='error-message'>{formik.errors.ulbCode}</div> : null}
                                                </div>

                                                <div className='col-lg-3 col-md-6'>
                                                    <p className='lebel-card-text m-0'>Zone No.</p>
                                                    <input name="zoneNo" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.zoneNo} placeholder='Zone No.*' />
                                                    {formik.touched.zoneNo && formik.errors.zoneNo ? <div className='error-message'>{formik.errors.zoneNo}</div> : null}
                                                </div>
                                                <div className='col-lg-3 col-md-6'>
                                                    <p className='lebel-card-text m-0'>Select Ward</p>
                                                    <Select options={wards} value={selectedWard} onChange={handleWard} placeholder="Select Ward*" isClearable isDisabled={!selectedUlb} isLoading={isWardLoading} onBlur={() => formik.setFieldTouched('wardNo', true)} />
                                                    {formik.touched.wardNo && formik.errors.wardNo ? <div className='error-message'>{formik.errors.wardNo}</div> : null}
                                                </div>
                                            </>
                                        }
                                        <div className='col-lg-3 col-md-6'>
                                            <p className='lebel-card-text m-0'>Pincode</p>
                                            <input name="pincode" type="text" className='form-control' onChange={formik.handleChange} onBlur={formik.handleBlur} value={formik.values.pincode} placeholder='Pincode*' maxLength="6" />
                                            {formik.touched.pincode && formik.errors.pincode ? <div className='error-message'>{formik.errors.pincode}</div> : null}
                                        </div>
                                    </div>



                                    <div className='row mt-4 justify-content-start' style={{ rowGap: "20px" }}>
                                        <div className='col-md-3'>
                                            <button type="button" className="btn-cancel w-100" data-bs-dismiss="modal" onClick={() => handleReset()}>Cancel</button>
                                        </div>
                                        <div className='col-md-3'>
                                            <button type="submit" className='btn-modal-submit w-100'>Save</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>


                <div className="modal fade" id="newRoleModal" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered addusermodal">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New Role</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    <img src="img/closebtn.svg" alt='img' width="20px" height="20px" />
                                </button>
                            </div>
                            <div className="modal-body p-0">
                                <form onSubmit={userRoleCreateFormik.handleSubmit}>
                                    <div>
                                        <label className='input-lebel'>Role name</label>
                                        <input
                                            id="userRoleName"
                                            name="userRoleName"
                                            type="text"
                                            className='form-control'
                                            onChange={userRoleCreateFormik.handleChange}
                                            value={userRoleCreateFormik.values.userRoleName}
                                            placeholder='User Role Name'
                                        />
                                        {userRoleCreateFormik.errors.userRoleName ? (
                                            <div>{userRoleCreateFormik.errors.userRoleName}</div>
                                        ) : null}
                                    </div>
                                    {/* <div>
                    <label className='input-lebel mt-3'>Status</label>
                    <div className="select-theme">
                      <RadioButton
                        name="dark"
                        id="dark"
                        value="Active"
                        text="Active"
                        onChange={onChangeTheme}
                        checked={theme.dark}
                      />
                      <RadioButton
                        name="light"
                        id="light"
                        value="Unactive"
                        text="Unactive"
                        onChange={onChangeTheme}
                        checked={theme.light}
                      />
                    </div>
                  </div> */}
                                    <div className='row justify-content-between mt-4' style={{ rowGap: "20px" }}>
                                        <div className='col-md-5'>
                                            <button type="button" className="btn-cancel" data-bs-dismiss="modal" aria-label="Close">
                                                Cancel
                                            </button>
                                        </div>
                                        <div className='col-md-5'>
                                            <button type="submit" className='btn-modal-submit w-100'>Save</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </>
    )
}


const DataImport = () => {
    const [manageRoles, setManageRoles] = useState("manage-users");
    const { isTheme } = useSelector((state) => state.currentStage)
    const roles = [
        { id: "manage-users", label: "Manage Users", content: <ManageUsers />, modalId: "#addUserModal", buttonLabel: "Add new user" },
        { id: "roles", label: "Roles", content: <Roles />, modalId: "#newRoleModal", buttonLabel: "Create new role" },
        { id: "permissions", label: "Permissions", content: <Permissions /> },
    ];

    return (
        <div>
            {/* Info Text */}
            <div className="row">
                <div className="col-lg-7 col-md-8">
                    <h6 className="tab-text mt-3">
                        This system allows the admin to define roles with specific permissions, ensuring that users only have access to the data and functions they need for their role.
                    </h6>
                </div>
            </div>

            {/* Role Tabs & Action Buttons */}
            <div className="row">
                <div className={["manage-users", "roles"].includes(manageRoles) ? "col-md-12" : "col-xxl-4 col-xl-5 col-lg-8 col-md-8"}>
                    <div className="adduserdivtab mb-1">
                        {/* Role Tabs */}
                        <div className="managetabs">
                            {roles.map((role) => (
                                <button
                                    key={role.id}
                                    onClick={() => setManageRoles(role.id)}
                                    className={`role-text ${manageRoles === role.id ? "role-active" : "role-inactive"} ${role.id === "permissions" ? "" : ""}`}
                                >
                                    {role.label}
                                </button>
                            ))}
                        </div>

                        {/* Action Buttons */}
                        {roles.map(
                            (role) =>
                                role.modalId && manageRoles === role.id && (
                                    <button key={role.id} className="role-active" data-bs-toggle="modal" data-bs-target={role.modalId}>
                                        {isTheme === 'light' ? <img src="img/plus-light.svg" alt="img" className="mx-2" /> :
                                            <img src="img/pluseicon.svg" alt="img" className="mx-2" />}
                                        {role.buttonLabel}
                                    </button>
                                )
                        )}
                    </div>
                </div>
            </div>

            {/* Dynamic Content Section */}
            <div className="tab-content">
                {roles.map(
                    (role) =>
                        manageRoles === role.id && (
                            <div key={role.id} className="tab-panel">
                                {role.content}
                            </div>
                        )
                )}
            </div>
        </div>
    )
}



const DataCataLog = () => {
    const [security, setSecurity] = useState("authentication"); // Default tab

    const handleSecurity = (id) => {
        setSecurity(id);
    };

    const securityOptions = [
        { id: "authentication", label: "2-Step Authentication", content: <TwoStepAuthContent /> },
        { id: "password", label: "Password", content: <PasswordContent /> },
    ];

    return (
        <div className="row">
            {/* Security Tabs */}
            <div className="col-xxl-4 col-xl-4 col-lg-5 col-md-6">
                <div className="managetabs mb-3 mt-3">
                    {securityOptions.map((option) => (
                        <button
                            key={option.id}
                            onClick={() => handleSecurity(option.id)}
                            className={`btn-feature ${security === option.id ? "btn-is-feature" : ""}`}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Security Content */}
            <div className='row'>
                <div className="col-xxl-8 col-xl-8 col-lg-7 col-md-6">
                    {securityOptions.map(
                        (option) =>
                            security === option.id && (
                                <div key={option.id} className="security-content">
                                    {option.content}
                                </div>
                            )
                    )}
                </div>
            </div>
        </div>
    );
};

// Example content components
const TwoStepAuthContent = () => (
    <div className='row px-2'>
        <div className='col-xl-9 col-lg-12  auth-cotaniner' >
            <div className='row ' style={{ rowGap: "10px" }}>
                <div className='col-md-10 align-self-center'>
                    <div className='authleftdiv'>
                        <h6>2-Step Verification for Login</h6>
                        <p className='m-0'>Enable 2-step verification to protect your account by requiring an additional verification step whenever you log in.</p>
                    </div>
                </div>
                <div className='col-md-2 systemdropdown'>
                    <div className='auth-switchdiv'>
                        <label className="switch">
                            <input type="checkbox" checked />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const PasswordContent = () => {
    const [showFormPass, setFormPass] = useState(false)
    const [CurrentPass, setCurentPass] = useState(true)
    const [newPass, setNewPass] = useState(true)
    const handlePassword = (data) => {
        if (data === "new") {
            setNewPass(!newPass)
        } else if (data === 'current') {
            setCurentPass(!CurrentPass)
        }

    }
    const showForm = () => {
        setFormPass(true)
    }
    return (
        <>
            <div className='row'>
                <div className='col-xl-8 col-lg-12' >
                    <div className='row '>
                        <div className='col-md-10 align-self-center'>
                            <div className='authleftdiv'>
                                <p className='m-0'>EKeep your account secure by updating your password regularly. Choose a strong password that you haven’t used before.</p>
                            </div>
                        </div>
                    </div>

                    <div className='update-message'>
                        <img src="img/calendarsilhouette.svg" alt='img' />
                        <h6 className='m-0'>Last password updated 21 days ago</h6>
                    </div>
                    <button className='role-active mb-2' onClick={() => showForm()}>Create new Password</button>
                </div>
            </div>
            {showFormPass && (
                <>
                    <form className='update-password'>
                        <div className='row'>
                            <div className='col-md-4'>
                                <label className='input-lebel'>Current password</label>
                                <div className='position-relative'>
                                    <input className='form-control' type={CurrentPass ? 'password' : 'text'}
                                        maxLength={8}
                                    />
                                    <div className='eyediv eyedivaccess'>
                                        <div type="button" onClick={() => handlePassword("current")}>
                                            {CurrentPass ? <FaEye /> : <FaEyeSlash />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-3'>
                            <div className='col-md-4'>
                                <label className='input-lebel'>New password</label>
                                <div className='position-relative'>
                                    <input className='form-control' type={newPass ? 'password' : 'text'}
                                        maxLength={8}
                                    />
                                    <div className='eyediv eyedivaccess'>
                                        <div type="button" onClick={() => handlePassword("new")}>
                                            {newPass ? <FaEye /> : <FaEyeSlash />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h6 className='requird-text'>Password requirements</h6>
                            <div className='update-message mt-2 mb-2'>
                                <img src="img/checked.svg" alt='img' />
                                <h6 className='message-text m-0'>At least 8 characters long</h6>
                            </div>
                            <div className='update-message mt-2 mb-2'>
                                <img src="img/checked.svg" alt='img' />
                                <h6 className='message-text m-0'>Includes one uppercase letter, one lowercase letter, and one number</h6>
                            </div>
                            <div className='update-message mt-2 mb-2'>
                                <img src="img/remove.svg" alt='img' />
                                <h6 className='message-text m-0'>Contains a special character (!, @, #, etc.)</h6>
                            </div>
                        </div>
                        <button className='role-active mt-2' onClick={() => showForm()}>Update Password</button>
                    </form>
                </>
            )}
        </>
    )
}

const ManageUsers = () => {
    const { isTheme } = useSelector((state) => state.currentStage);
    const [searchField, setSearchField] = useState('userId'); // default to userId
    const [searchQuery, setSearchQuery] = useState('');
    const [users, setUsers] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [districts, setDistricts] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [tokenAuth, setTokenAuth] = useState(null);
    const [selectedUlb, setSelectedUlb] = useState(null);
    const [ulbs, setUlbs] = useState([]);
    const [isUlbLoading, setIsUlbLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [selectedRole, setSelectedRole] = useState(null);
    const [departments, setDepartments] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState(null);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isDistrictLoading, setIsDistrictLoading] = useState(false);
    const [wards, setWards] = useState([]);
    const [selectedWard, setSelectedWard] = useState(null);
    const [isWardLoading, setIsWardLoading] = useState(false);
    const [designations, setDesignations] = useState([]);
    const navigate = useNavigate();
    const authData = useSelector(state => state.authToken.authData);
    const [deleteUserId, setDeleteUserId] = useState(null);

    console.log("selectedDistrict", selectedDistrict)
    useEffect(() => {
        const token = localStorage.getItem("token");
        setTokenAuth(token)
    }, [])

    const fetchGetUser = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { userId: 'all' };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userDetails(value, config);
            const data = response.data?.data || [];
            setUsers(data);
        } catch (error) {
            console.error('Error fetching users', error);
        }
    };

    const handleSearchSubmit = async () => {
        try {
            const body = {
                searchBy: searchField,
                searchValue: searchQuery?.toUpperCase() || ""
            };

            const config = {
                headers: {
                    Authorization: `Bearer ${tokenAuth}`,
                    'Content-Type': 'application/json'
                }
            };

            console.log("config", config)

            const response = await GisApiServices.getSearchUsers(body, config);
            const data = response.data?.data || [];
            console.error('Error searching users', response);
            setUsers(data);
        } catch (error) {
            console.error('Error searching users', error?.response?.data?.message);
            toast.error(error?.response?.data?.message);
        }
    };

    useEffect(() => {
        fetchDesignations()
        fetchDepartments()
        fetchUserRoles()
        // you can also call formikEdit.setFieldValue here if needed
    }, []);

    const fetchGetUserSingle = async (userId) => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userDetails({ userId }, config);
            const data = response.data?.data?.[0] || {};

            console.log("datadata", data)


            // Fetch and match district
            const districtsList = await fetchDistricts();
            const matchedDistrict = Array.isArray(districtsList)
                ? districtsList.find(d => d.label === data.districtname)
                : null;
            setSelectedDistrict(matchedDistrict);

            // Fetch and match ULB if district is matched
            let matchedUlb = null;
            if (matchedDistrict) {
                const ulbsList = await fetchUlbs(matchedDistrict.value);
                matchedUlb = Array.isArray(ulbsList)
                    ? ulbsList.find(u => u.label === data.ulbname)
                    : null;
            }
            setSelectedUlb(matchedUlb);


            // Fetch and match Ward if ULB and district are matched
            let matchedWard = null;
            if (matchedDistrict && matchedUlb) {
                const wardList = await fetchWards(matchedDistrict.value, matchedUlb.value);
                console.log("wardList", wardList)
                // console.log("departments",departments)
                console.log("data.wardNo", data.wardNo)
                matchedWard = Array.isArray(wardList)
                    ? wardList.find(w => w?.value?.startsWith(data?.wardNo))
                    : null;
            }
            setSelectedWard(matchedWard);

            // Fetch and match Role
            const rolesList = roles.length > 0 ? roles : await fetchUserRoles();
            if (Array.isArray(rolesList) && roles.length === 0) {
                setRoles(rolesList);
            }

            const matchedRole = Array.isArray(rolesList)
                ? rolesList.find(r => r.label === data?.userRole)
                : null;
            setSelectedRole(matchedRole);
            formikEdit.setFieldValue("userRoleId", matchedRole?.value || "");

            // Fetch and match Department
            // const departmentList = await fetchDepartments();
            const matchedDepartment = Array.isArray(departments)
                ? departments.find(d => d.label === data.department)
                : null;

            setSelectedDepartment(matchedDepartment);
            formikEdit.setFieldValue("departmentId", matchedDepartment?.value || "");
            // setSelectedDepartment(matchedDepartment);



            let matchedDesignation = null;
            if (matchedDepartment) {
                const designationList = await fetchDesignations();
                matchedDesignation = Array.isArray(designationList)
                    ? designationList.find(d => d.label === data.designation)
                    : null;
                setSelectedDesignation(matchedDesignation);
                formikEdit.setFieldValue("designationId", matchedDesignation?.value || "");
            }

            // Prepare form data
            const userData = {
                userId: data.userId || '',
                firstName: data.firstName || '',
                lastName: data.lastName || '',
                email: data.email || '',
                mobileNumber: data.mobileNumber || '',
                userType: data.userType || '',
                userPassword: data.password || '',
                address: data.address || '',
                city: data.city || '',
                pincode: data.pincode || '',
                zoneNo: data.zoneNo || '',
                districtname: matchedDistrict?.label || '',
                distCode: matchedDistrict?.value || '',
                ulbname: matchedUlb?.label || '',
                ulbCode: matchedUlb?.value || '',
                wardNo: matchedWard?.value || '',
                userRoleId: matchedRole?.value || '',
                departmentId: matchedDepartment?.value || '',
                designationId: matchedDesignation?.value || '',
                createdby: authData?.UserID || ''
            };

            console.log("Fetched user data:", userData);
            formikEdit.setValues(userData);

        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };



    const formikEdit = useFormik({
        initialValues: {
            userId: '',
            userPassword: '',
            email: '',
            firstName: '',
            lastName: '',
            userFullName: '',
            designationId: '',
            mobileNumber: '',
            departmentId: '',
            panNumber: 'GIUWJ8385U',
            panNumber: '',
            address: '',
            city: '',
            distCode: '',
            districtname: '', // Local-only, not sent to API
            stateCode: '',
            countryCode: '',
            pincode: '',
            userType: '',
            ulbCode: '',
            ulbname: '',       // Local-only, not sent to API
            zoneNo: '',
            wardNo: '',
            userRoleId: '',
            stateCode: '23',
            countryCode: '91',
            createdby: authData?.UserID,
            userPassword: ''
        },
        enableReinitialize: true,

        onSubmit: async (values, { resetForm }) => {
            try {
                const { ulbname, districtname, ...payload } = values; // Exclude local display-only fields
                const authToken = localStorage.getItem('token');
                // Inject controlled values from UI states
                payload.userRoleId = selectedRole?.value || '';
                payload.departmentId = selectedDepartment?.value || '';
                payload.wardNo = selectedWard?.value || '';
                payload.userFullName = `${values.firstName} ${values.lastName}`.trim();
                payload.stateCode = '23';
                payload.countryCode = '91';
                payload.panNumber = 'GIUWJ8385U';

                console.log("Submitting user payload", payload);

                const config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                };

                const response = await GisApiServices.userEditDetails(payload, config);

                if (response.data.message === "Success") {
                    toast.success(response.data.message);
                    resetForm();
                    setSelectedDistrict(null);
                    setSelectedUlb(null);
                    setSelectedWard(null);
                    setSelectedRole(null);
                    setSelectedDepartment(null);
                    setSelectedDesignation(null);
                } else {
                    toast.success(response.data.message);
                }
            } catch (error) {
                console.error(error);
                toast.error('Failed to update user');
            }
        }
    });



    const fetchDesignations = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 2 };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setDesignations(formatted);
            return formatted;
        } catch (error) {
            console.error("Error fetching designations", error);
            return [];
        } finally {
        }
    };


    useEffect(() => {
        fetchGetUser();
    }, []);

    const handleDeletUser = async (userId) => {
        setDeleteUserId(userId); // store the user id
        const modal = new window.bootstrap.Modal(
            document.getElementById("deleteUserModal")
        );
        modal.show();
        // try {
        //     const authToken = localStorage.getItem('token');
        //     if (!authToken) {
        //         console.error("No auth token found");
        //         navigate("/login");
        //         return;
        //     }
        //     const value = { userId: userId };
        //     const config = {
        //         headers: {
        //             Authorization: `Bearer ${authToken}`,
        //             'Content-Type': 'application/json'
        //         }
        //     };
        //     const response = await GisApiServices.DeleteUserDetails(value, config);
        //     const data = response.data?.statusCode || [];
        //     console.log("data user:", data);
        //     if (data) {
        //         fetchGetUser();
        //     }
        // } catch (error) {
        //     console.error("Error fetching designations", error);
        //     return [];
        // }
    };


    const confirmDeleteUser = async () => {
        if (!deleteUserId) return;

        try {
            const authToken = localStorage.getItem("token");
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }

            const value = { userId: deleteUserId };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    "Content-Type": "application/json",
                },
            };

            const response = await GisApiServices.DeleteUserDetails(value, config);
            const data = response.data?.statusCode || [];

            console.log("delete response:", data);

            if (data) {
                toast.success(response?.data?.message);
                fetchGetUser();
            }
        } catch (error) {
            console.error("Error deleting user", error);
        } finally {
            setDeleteUserId(null);
            const modalEl = document.getElementById("deleteUserModal");
            const modal = window.bootstrap.Modal.getInstance(modalEl);
            if (modal) modal.hide();
        }
    };


    const columns = [
        {
            name: 'User ID',
            selector: (row) => row.userId,
            sortable: true,
        },

        {
            name: 'ULB Name',
            selector: (row) => row.ulbname,
            sortable: true,
        },
        {
            name: 'User Role',
            selector: (row) => row.userRole,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row) => row.email,
            sortable: true,
        },
        {
            name: 'User Type',
            selector: (row) => row.userType,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row) => row.status,
            sortable: true,
        },
        {
            name: 'Quick Actions',
            cell: (row) => (
                <div className="d-flex justify-content-center gap-2">
                    <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal" onClick={() => fetchGetUserSingle(row.userId)}>
                        <img
                            src={isTheme === 'light' ? 'img/pencil-light.svg' : 'img/pencil.svg'}
                            alt="edit"
                        />
                    </div>
                    <div type="button" onClick={() => handleDeletUser(row.userId)}>
                        <img
                            src={isTheme === 'light' ? 'img/trash-bin-light.svg' : 'img/trashbin.svg'}
                            alt="delete"
                        />
                    </div>
                </div>
            ),
        },
    ];

    const filteredUsers = users.filter((user) =>
        Object.values(user).some((val) =>
            String(val).toLowerCase().includes(filterText.toLowerCase())
        )
    );


    const fetchDistricts = async () => {
        try {
            setIsDistrictLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                distCode: "0",
                ublCode: "0",
                fectchtype: "1",
            };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];

            const formatted = data.map((item) => ({
                value: item.district_Code,
                label: item.name,
            }));

            setDistricts(formatted);
            return formatted;
        } catch (error) {
            console.error("Error fetching districts", error);
            return [];
        } finally {
            setIsDistrictLoading(false);
        }
    };

    const fetchUlbs = async (districtCode) => {
        try {
            setIsUlbLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const value = {
                distCode: districtCode,
                ublCode: "0",
                fectchtype: "2",
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];

            const formatted = data.map((item) => ({
                value: item.ulb_Code,
                label: item.name,
            }));

            setUlbs(formatted);
            return formatted;
        } catch (error) {
            console.error("Error fetching ULBs", error);
            return [];
        } finally {
            setIsUlbLoading(false);
        }
    };

    const fetchUserRoles = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 3 }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setRoles(formatted);
        } catch (error) {
            console.error("Error fetching user roles", error);
        } finally {
        }
    };

    const fetchDepartments = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { fectchtypeID: 1 }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.getDepartDesignation(value, config);
            const data = response.data?.data || [];
            const formatted = data.map((item) => ({
                value: item.id,
                label: item.name,
            }));
            setDepartments(formatted);
        } catch (error) {
            console.error("Error fetching departments", error);
        } finally {
        }
    };



    const handleDistrictChange = (selectedOption) => {
        setSelectedDistrict(selectedOption);
        setSelectedUlb(null);
        setUlbs([]);
        console.log("selectedOption", selectedOption)
        if (selectedOption) {
            fetchUlbs(selectedOption.value);
        }
    };

    const handleUlbChange = async (selectedOption) => {
        setSelectedUlb(selectedOption);
        setSelectedWard(null);
        setWards([]);

        if (selectedOption && selectedDistrict) {
            await fetchWards(selectedDistrict.value, selectedOption.value);
        }
    };

    const handleWard = (selectedOption) => {
        setSelectedWard(selectedOption);
        formikEdit.setFieldValue('wardNo', selectedOption?.value || '');
    };

    const handleRole = (selectedOption) => {
        setSelectedRole(selectedOption)
    }

    const handleDepartment = (selectedOption) => {
        setSelectedDepartment(selectedOption)
    }

    const handleDesignations = (selectedOption) => {
        setSelectedDesignation(selectedOption)
        formikEdit.setFieldValue('designationId', selectedOption?.value || '');
    }


    const fetchWards = async (districtCode, ulbCode) => {
        try {
            setIsWardLoading(true);
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const value = {
                distCode: districtCode,
                ublCode: ulbCode,
                fectchtype: "3",
            };
            const response = await GisApiServices.getUlbDistrict(value, config);
            const data = response.data?.data || [];

            const formatted = data.map((item) => ({
                value: item.ward_ID,
                label: `${item.wardNo} - ${item.name}`,
            }));

            setWards(formatted);
            return formatted;
        } catch (error) {
            console.error("Error fetching Wards", error);
            return [];
        } finally {
            setIsWardLoading(false);
        }
    };

    const customStyles = {
        table: {
            style: {
                // backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
                background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                color: isTheme === 'dark' ? 'white' : 'black',
            },
        },
        headRow: {
            style: {
                background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                // backgroundColor: isTheme === 'dark' ? '#002864' : '#1F509A',
                color: 'white',
            },
        },
        headCells: {
            style: {
                color: 'white',
                fontWeight: 'bold',
                // backgroundColor: isTheme === 'dark' ? '#002864' : '#1F509A',
                //  background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
            },
        },
        rows: {
            style: {
                backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
                color: isTheme === 'dark' ? 'white' : 'black',
            },
        },
        cells: {
            style: {
                color: isTheme === 'dark' ? 'white' : 'black',
                backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
            },
        },
    };

    const customStyles2 = {
        control: (base, state) => ({
            ...base,
            backgroundColor: isTheme === "light" ? "rgb(245, 245, 245)" : "#002864",
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "12px",
            border: isTheme === "light" ? "#000" : "none",
            boxShadow: "none",
            outline: "none",
            opacity: state.isDisabled ? 0.6 : 1,
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
            maxHeight: "300px",
            overflowY: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::-webkit-scrollbar": { display: "none" }
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#16386C"
                : state.isFocused
                    ? isTheme === "light" ? "#1F509A" : "#16386C"
                    : isTheme === "light" ? "#EBEBEB" : "#FFFFFF",
            color: state.isSelected || state.isFocused ? "#FFFFFF" : "#000", // Ensure text is white when selected or hovered
            fontSize: "12px",
            padding: "10px",
            cursor: "pointer",
            "&:hover": {
                backgroundColor: isTheme === "light" ? "#1F509A" : "#16386C",
                color: "#FFFFFF", // Force white text on hover
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "12px"
        }),
        placeholder: (base, state) => ({
            ...base,
            color: state.isDisabled ? isTheme === "light" ? "#000" : "rgba(255, 255, 255, 0.75)" : isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "12px"
        }),
        input: (provided) => ({
            ...provided,
            color: isTheme === "light" ? "#000" : "#FFFFFF",
            fontSize: "12px"
        })
    };

    return (
        <>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            <h6 className="table-title">Manage Users</h6>
            <div className='row mb-3'>
                <div className='col-md-8'>
                    <div className='d-flex flex-wrap gap-2 align-items-center'>
                        <div className="search-container1">
                            <input
                                className="access-search"
                                placeholder={`Search ${searchField}`}
                                style={{ maxWidth: '300px' }}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                            <span className="search-img">
                                {isTheme === "light" ? (
                                    <img src="img/bluesearch.svg" alt="search" />
                                ) : (
                                    <img src="img/Vectorsearch.png" alt="search" />
                                )}
                            </span>
                        </div>
                        <Select
                            options={[
                                { value: 'userId', label: 'User ID' },
                                { value: 'name', label: 'Name' },
                                { value: 'email', label: 'Email' },
                            ]}
                            defaultValue={{ value: 'userId', label: 'User ID' }}
                            onChange={(selectedOption) => setSearchField(selectedOption.value)}
                            styles={customStyles2}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: isTheme === 'dark' ? '#002864' : '#e6f0ff',
                                    primary: isTheme === 'dark' ? '#16386C' : '#1F509A',
                                },
                            })}
                        />

                        <button
                            className="role-active"
                            onClick={handleSearchSubmit}
                            disabled={!searchField || !searchQuery} // optional safety
                        >
                            Submit
                        </button>
                    </div>

                </div>
            </div>

            <DataTable
                columns={columns}
                data={filteredUsers}
                pagination
                responsive
                noDataComponent="No users found"
                customStyles={customStyles}
                persistTableHead
            />

            <div className="modal fade" id="deleteUserModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="d-flex justify-content-between p-2">
                            <h5 className="modal-title">Confirm Delete</h5>
                            <button type="button" className="btn-close py-0" data-bs-dismiss="modal" aria-label="Close">
                                <img src="img/closebtn.svg" alt="img" width="20px" height="20px" />
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure you want to delete this user?
                        </div>
                        <div className="p-2 d-flex justify-content-between gap-2">
                            <button
                                type="button"
                                className="btn-cancel"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn-modal-submit w-100"
                                onClick={confirmDeleteUser}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="editUserModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-xl modal-dialog-centered addusermodal addusermodal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Edit user</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <img src="img/closebtn.svg" alt='img' width="20px" height="20px" />
                            </button>
                        </div>
                        <div className="modal-body p-0">
                            <form onSubmit={formikEdit.handleSubmit}>
                                <h5 className='modal-headings'>Personal Details</h5>
                                <div className='row' style={{ rowGap: "15px" }}>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>User Id</p>
                                        <input
                                            id="userId"
                                            name="userId"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='User Id'
                                            value={formikEdit.values.userId}
                                        />
                                        {formikEdit.errors.userId ? <div>{formikEdit.errors.userId}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>First Name</p>
                                        <input
                                            id="firstName"
                                            name="firstName"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='First Name'
                                            value={formikEdit.values.firstName}
                                        />
                                        {formikEdit.errors.firstName ? <div>{formikEdit.errors.firstName}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Last Name</p>
                                        <input
                                            id="lastName"
                                            name="lastName"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='Last Name'
                                            value={formikEdit.values.lastName}
                                        />
                                        {formikEdit.errors.lastName ? <div>{formikEdit.errors.lastName}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Email</p>
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            value={formikEdit.values.email}
                                            placeholder='Email Address'
                                        />
                                        {formikEdit.errors.email ? <div>{formikEdit.errors.email}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Mobile Number</p>
                                        <input
                                            id="mobileNumber"
                                            name="mobileNumber"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='Phone number'
                                            value={formikEdit.values.mobileNumber}
                                            maxLength="10"
                                        />
                                        {formikEdit.errors.mobileNumber ? <div>{formikEdit.errors.mobileNumber}</div> : null}
                                    </div>

                                    {/* <div className='col-lg-3 col-md-6'>
                    <input
                      id="userPassword"
                      name="userPassword"
                      type="password"
                      className='form-control'
                      onChange={formikEdit.handleChange}
                      placeholder='userPassword'
                      value={formikEdit.values.userPassword}
                    />
                    {formikEdit.errors.userPassword ? <div>{formikEdit.errors.userPassword}</div> : null}
                  </div> */}

                                </div>



                                <h5 className='modal-headings'>User Profile Details</h5>
                                <div className='row' style={{ rowGap: "20px" }}>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Select Role</p>
                                        <Select
                                            options={roles}
                                            value={selectedRole}
                                            onMenuOpen={fetchUserRoles}
                                            onChange={handleRole}
                                            placeholder="Select Role"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <div className='newuserselect'>
                                            <p className='lebel-card-text m-0'>Select User Type</p>
                                            <select
                                                id="userType"
                                                name="userType"
                                                className="form-select"
                                                onChange={formikEdit.handleChange}
                                                value={formikEdit.values.userType}
                                            >
                                                <option value="" disabled>Select Role Type</option>
                                                <option value="Admin">Admin</option>
                                                <option value="User">User</option>
                                                <option value="User">District User</option>
                                            </select>
                                            {formikEdit.errors.userType ? (
                                                <div className="text-danger">{formikEdit.errors.userType}</div>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Select Department</p>
                                        <Select
                                            options={departments}
                                            value={selectedDepartment}
                                            onMenuOpen={fetchDepartments}
                                            onChange={handleDepartment}
                                            placeholder="Select Department"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Select Designations</p>
                                        <Select
                                            options={designations}
                                            value={selectedDesignation}
                                            onMenuOpen={fetchDesignations}
                                            onChange={handleDesignations}
                                            placeholder="Select Designation"
                                            isClearable
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                        />
                                    </div>




                                </div>



                                <h5 className='modal-headings'>User Address Details</h5>
                                <div className='row'>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Address</p>
                                        <input
                                            id="address"
                                            name="address"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='Address'
                                            value={formikEdit.values.address}
                                        />
                                        {formikEdit.errors.address ? <div>{formikEdit.errors.address}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>City</p>
                                        <input
                                            id="city"
                                            name="city"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='City'
                                            value={formikEdit.values.city}
                                        />
                                        {formikEdit.errors.city ? <div>{formikEdit.errors.city}</div> : null}
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>District</p>
                                        <Select
                                            options={districts}
                                            value={selectedDistrict}
                                            onMenuOpen={fetchDistricts}
                                            onChange={handleDistrictChange}
                                            placeholder="Select District"
                                            isClearable
                                            isLoading={isDistrictLoading}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                            className="mb-4"
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>ULB</p>
                                        <Select
                                            options={ulbs}
                                            value={selectedUlb}
                                            onChange={handleUlbChange}
                                            placeholder="Select ULB"
                                            isClearable
                                            isDisabled={!selectedDistrict}
                                            isLoading={isUlbLoading}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                            className="mb-4"
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Zone NO.</p>
                                        <input
                                            id="zoneNo"
                                            name="zoneNo"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='zoneNo'
                                            value={formikEdit.values.zoneNo}
                                        />
                                        {formikEdit.errors.zoneNo ? <div>{formikEdit.errors.zoneNo}</div> : null}
                                    </div>

                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Select Ward</p>
                                        <Select
                                            options={wards}
                                            value={selectedWard}
                                            onChange={handleWard}
                                            placeholder="Select Ward"
                                            isClearable
                                            isDisabled={!selectedUlb}
                                            isLoading={isWardLoading}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    borderColor: "#ccc",
                                                    boxShadow: "none",
                                                    "&:hover": { borderColor: "#aaa" },
                                                }),
                                            }}
                                        />
                                    </div>
                                    <div className='col-lg-3 col-md-6'>
                                        <p className='lebel-card-text m-0'>Pincode</p>
                                        <input
                                            id="pincode"
                                            name="pincode"
                                            type="text"
                                            className='form-control'
                                            onChange={formikEdit.handleChange}
                                            placeholder='pincode'
                                            value={formikEdit.values.pincode}
                                        />
                                        {formikEdit.errors.pincode ? <div>{formikEdit.errors.pincode}</div> : null}
                                    </div>
                                </div>


                                <div className='row mt-4' style={{ rowGap: "15px" }}>
                                    <div className='col-md-3'>
                                        <button type="button" className="btn-cancel" data-bs-dismiss="modal" aria-label="Close">
                                            Cancel
                                        </button>
                                    </div>
                                    <div className='col-md-3'>
                                        <button type="submit" className='btn-modal-submit w-100'>Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};



const Roles = () => {
    const { isTheme } = useSelector((state) => state.currentStage)
    const [users, setUsers] = useState([]);
    const navigate = useNavigate();
    const [tokenAuth, setTokenAuth] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [selectedRoleDetails, setSelectedRoleDetails] = useState(null);
    useEffect(() => {
        fetchGetUser();
    }, []);

    const handleDeletRole = async (roleId) => {
        console.log("sdflksdf", roleId)

        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = { userRoleId: roleId };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.DeleteUserRole(value, config);
            const data = response.data?.statusCode || [];
            console.log("data user:", data);
            if (data) {
                fetchGetUser();
                toast.success(response.data?.message)
            }
        } catch (error) {
            console.error("Error fetching designations", error?.response?.data?.message);
            toast.error(error?.response?.data?.message)
        }
    };

    const handleEditRole = (row) => {
        setSelectedRoleDetails(row);
    };

    const formik = useFormik({
        enableReinitialize: true,   // important so values reset when you setSelectedRoleDetails
        initialValues: {
            name: selectedRoleDetails?.userRoleName || "",
            status: selectedRoleDetails?.userRoleStatus || "",  // no forced Active here
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Role name is required"),
            status: Yup.string().oneOf(["Active", "Unactive"]).required("Status is required"),
        }),
        onSubmit: async (values) => {
            try {
                const authToken = localStorage.getItem("token");
                if (!authToken) {
                    navigate("/login");
                    return;
                }

                const config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        "Content-Type": "application/json",
                    },
                };

                const body = {
                    userRoleId: selectedRoleDetails?.userRoleId,
                    userRoleName: values.name,
                    userRoleStatus: values.status,
                };

                const response = await GisApiServices.EditUserRole(body, config);

                if (response.data?.statusCode === 200) {
                    toast.success(response.data?.message);
                    fetchGetUser();
                }
            } catch (err) {
                console.error("Error updating role:", err);
            }
        },
    });



    console.log("selectedRoleDetailsselectedRoleDetails", selectedRoleDetails)

    const columns = [
        {
            name: 'User ID',
            selector: (row) => row.userRoleId,
            sortable: true,
        },

        {
            name: 'Role Name',
            selector: (row) => row.userRoleName,
            sortable: true,
        },
        {
            name: 'Role Status',
            selector: (row) => row.userRoleStatus,
            sortable: true,
        },
        {
            name: 'Quick Actions',
            cell: (row) => (
                <div className='checkoxdiv justify-content-center'>
                    <div
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#editRoleModal"
                        onClick={() => handleEditRole(row)}
                    >
                        {isTheme === "light"
                            ? <img src="img/pencil-light.svg" alt="edit" />
                            : <img src="img/pencil.svg" alt="edit" />
                        }
                    </div>
                    <div
                        type="button"
                        onClick={() => handleDeletRole(row.userRoleId)}
                    >
                        {isTheme === "light"
                            ? <img src="img/trash-bin-light.svg" alt="delete" />
                            : <img src="img/trashbin.svg" alt="delete" />
                        }
                    </div>
                </div>
            ),
        },
    ];

    useEffect(() => {
        const token = localStorage.getItem("token");
        setTokenAuth(token)
    }, [])

    const fetchGetUser = async () => {
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                userRoleId: 0,
                userRoleName: "string",
                userRoleStatus: "string"
            };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userRoleDetails(value, config);
            const roles = response.data?.data || [];
            setUsers(roles);
        } catch (error) {
            console.error("Error fetching user roles:", error);
        } finally {
        }
    };

    const filteredUsers = users.filter((user) =>
        Object.values(user).some((val) =>
            String(val).toLowerCase().includes(filterText.toLowerCase())
        )
    );

    const customStyles = {
        table: {
            style: {
                // backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
                background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                color: isTheme === 'dark' ? 'white' : 'black',
            },
        },
        headRow: {
            style: {
                // backgroundColor: isTheme === 'dark' ? '#002864' : '#1F509A',
                background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                color: 'white',
            },
        },
        headCells: {
            style: {
                color: 'white',
                fontWeight: 'bold',
                // background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                // backgroundColor: isTheme === 'dark' ? '#002864' : '#1F509A',
            },
        },
        rows: {
            style: {
                background: "linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                // backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
                color: isTheme === 'dark' ? 'white' : 'black',
            },
        },
        cells: {
            style: {
                color: isTheme === 'dark' ? 'white' : 'black',
                backgroundColor: isTheme === 'dark' ? '#16386C' : 'white',
            },
        },
    };
    return (
        <div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            <h6 className="table-title">Manage Users</h6>
            <DataTable
                columns={columns}
                data={filteredUsers}
                pagination
                responsive
                noDataComponent="No users found"
                customStyles={customStyles}
                persistTableHead
            />

            <div className="modal fade" id="editRoleModal" tabindex="-1" aria-labelledby="exampleModalLabel3" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered addusermodal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Edit Role</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                <img src="img/closebtn.svg" alt='img' width="20px" height="20px" />
                            </button>
                        </div>
                        <div className="modal-body p-0">
                            <form onSubmit={formik.handleSubmit}>
                                <div>
                                    <label className='input-lebel'>Role name</label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        className='form-control'
                                        onChange={formik.handleChange}
                                        placeholder='Enter user name here'
                                        value={formik.values.name}
                                    />
                                    {formik.errors.name ? <div>{formik.errors.name}</div> : null}
                                </div>
                                <div>
                                    <label className='input-lebel mt-3'>Status</label>
                                    <div className="select-theme">
                                        <RadioButton
                                            name="status"
                                            id="active"
                                            value="Active"
                                            text="Active"
                                            onChange={formik.handleChange}
                                            checked={formik.values.status === "Active"}   // will check if Active
                                        />

                                        <RadioButton
                                            name="status"
                                            id="inactive"
                                            value="Unactive"
                                            text="Unactive"
                                            onChange={formik.handleChange}
                                            checked={formik.values.status === "Unactive"}  // will check if Unactive
                                        />
                                    </div>
                                </div>
                                <div className='row justify-content-between mt-4' style={{ rowGap: "20px" }}>
                                    <div className='col-md-5'>
                                        <button type="button" className="btn-cancel" data-bs-dismiss="modal" aria-label="Close">
                                            Cancel
                                        </button>
                                    </div>
                                    <div className='col-md-5'>
                                        <button type="submit" className='btn role-active w-100'>Save</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Permissions = () => {
    const [userRoles, setUserRoles] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedPermissions, setSelectedPermissions] = useState([]);
    const navigate = useNavigate();
    const authData = useSelector((state) => state.authToken.authData);

    const fetchUserRoles = async () => {
        setIsLoading(true);
        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const value = {
                userRoleId: 0,
                userRoleName: "string",
                userRoleStatus: "string"
            };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userRoleDetails(value, config);
            const roles = response.data?.data || [];
            const formattedRoles = roles.map((role) => ({
                value: role.userRoleId,
                label: role.userRoleName
            }));
            setUserRoles(formattedRoles);
        } catch (error) {
            console.error("Error fetching user roles:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRoleChange = async (selectedOption) => {
        setSelectedRole(selectedOption);
        setSelectedPermissions([]);
        if (!selectedOption?.value) return;

        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const payload = { role_Id: selectedOption.value };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userPermissions(payload, config);
            const existingPermissions = response.data?.data?.permissions || [];
            setSelectedPermissions(existingPermissions);
        } catch (error) {
            console.error("Failed to fetch permissions:", error);
            toast.error("Could not load permissions for selected role.");
        }
    };

    const checkboxModules = [
        {
            moduleName: "GIS Tools",
            moduleId: "M1",
            options: [
                { label: "Search My Property", activityId: "G1" },
                { label: "Solar potential", activityId: "G2" },
                { label: "Water Quality", activityId: "G3" },
                { label: "Buffer analysis", activityId: "G4" },
                { label: "GIS Query", activityId: "G5" },
                { label: "Download Map Tool", activityId: "G6" },
                { label: "Change Analysis", activityId: "G7" },
                { label: "Water level rise", activityId: "G8" },
                { label: "Tax Evaluation Analysis", activityId: "G9" },
                { label: "Comparison Tool", activityId: "G10" }
            ]
        },
        {
            moduleName: "MIS Module",
            moduleId: "M2",
            options: [{ label: "MIS Dashboard", activityId: "MI1" }]
        },
        {
            moduleName: "Activities",
            moduleId: "M3",
            options: [
                { label: "Recent Activities", activityId: "A1" },
                { label: "Notifications", activityId: "A2" },
                { label: "User Activity", activityId: "A3" }
            ]
        },
        {
            moduleName: "Data Management",
            moduleId: "M4",
            options: [
                { label: "Data Import", activityId: "D1" },
                { label: "Data Catalog", activityId: "D2" },
                { label: "Data Backup & Recovery", activityId: "D3" }
            ]
        },
        {
            moduleName: "Access & Security",
            moduleId: "M5",
            options: [
                { label: "Data Import", activityId: "AS1" },
                { label: "Data Catalog", activityId: "AS2" }
            ]
        },
        {
            moduleName: "GIS AI (GARUD)",
            moduleId: "M6",
            options: [{ label: "GIS AI Module", activityId: "AI1" }]
        },
        {
            moduleName: "Settings",
            moduleId: "M7",
            options: [
                { label: "System Preferences", activityId: "S1" },
                { label: "API Management", activityId: "S2" },
                { label: "Integration Management", activityId: "S3" }
            ]
        }
    ];

    const handleCheckboxChange = (moduleId, activityId) => {
        setSelectedPermissions((prev) => {
            const exists = prev.some(
                (item) => item.activityId === activityId && item.moduleId === moduleId
            );
            if (exists) {
                return prev.filter(
                    (item) => !(item.activityId === activityId && item.moduleId === moduleId)
                );
            } else {
                return [...prev, { moduleId, activityId }];
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedRole?.value) {
            toast.error("Please select a role before submitting.");
            return;
        }

        if (selectedPermissions.length === 0) {
            toast.error("Please select at least one permission.");
            return;
        }

        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const checkPayload = { role_Id: selectedRole.value };
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const existingRes = await GisApiServices.userPermissions(checkPayload, config);
            const existingPermissions = existingRes.data?.data?.permissions || [];

            if (existingPermissions.length > 0) {
                await handleEdit(); // Update
            } else {
                const authToken = localStorage.getItem('token');
                if (!authToken) {
                    console.error("No auth token found");
                    navigate("/login");
                    return;
                }
                const config = {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                };
                const createPayload = {
                    role_Id: selectedRole.value,
                    assignedBy: authData?.UserID,
                    permissions: selectedPermissions
                };
                const createRes = await GisApiServices.userCreatePermission(createPayload, config);
                toast.success(createRes.data.message);
                console.log("Created:", createRes.data);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Submission failed");
        }
    };

    const handleEdit = async () => {
        const payload = {
            role_Id: selectedRole.value,
            assignedBy: authData?.UserID || "admin",
            permissions: selectedPermissions
        };

        try {
            const authToken = localStorage.getItem('token');
            if (!authToken) {
                console.error("No auth token found");
                navigate("/login");
                return;
            }
            const config = {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            };
            const response = await GisApiServices.userPermissionsEdit(payload, config);
            toast.success(response.data.message);
            console.log("Edited:", response.data);
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to edit permissions");
        }
    };

    return (
        <div>
            <h6 className="table-title">Permission Management</h6>

            <form>
                <div>
                    <label className="lebel-text">Select role to get and set permission</label>
                    <div className="row">
                        <div className="col-xl-3 col-md-5">
                            <Select
                                options={userRoles}
                                value={selectedRole}
                                onMenuOpen={fetchUserRoles}
                                onChange={handleRoleChange}
                                placeholder="Select User Role"
                                isClearable
                                isLoading={isLoading}
                                className="mb-4"
                            />
                        </div>
                    </div>
                </div>
            </form>

            <form onSubmit={handleSubmit}>
                <div className="row">
                    {checkboxModules.map((module) => (
                        <div key={module.moduleId} className="mb-4">
                            <h5>{module.moduleName}</h5>
                            <div className="row">
                                {module.options.map((option) => (
                                    <div key={`${module.moduleId}-${option.activityId}`} className="col-md-4 mb-2">
                                        <div className="checkoxdiv">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`checkbox-${module.moduleId}-${option.activityId}`}
                                                onChange={() => handleCheckboxChange(module.moduleId, option.activityId)}
                                                checked={selectedPermissions.some(
                                                    (item) =>
                                                        item.activityId === option.activityId &&
                                                        item.moduleId === module.moduleId
                                                )}
                                            />
                                            <label
                                                className="permission-title"
                                                htmlFor={`checkbox-${module.moduleId}-${option.activityId}`}
                                            >
                                                {option.label}
                                            </label>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="row mt-4">
                    <div className="col-md-3">
                        <button type="submit" className="btn-modal-submit w-100">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};







const RadioButton = ({ name, id, value, onChange, checked, text }) => {
    return (
        <label className="radio-label">
            <input
                className="radio-input"
                type="radio"
                name={name}
                id={id}
                value={value}
                onChange={onChange}
                checked={checked}
            />
            <span className="custom-radio" />
            {text}
        </label>
    )
}